/**
 * Los 33 idiomas de la 2.0 (sección 13, decisión del 11/10). `es` es la fuente; `en`, `hu` y
 * `ca` con revisión humana; el resto generado con IA y glosario fijo.
 */
export const LANGUAGES = [
  // 14 actuales
  'es',
  'en',
  'fr',
  'de',
  'it',
  'pt',
  'nl',
  'pl',
  'sv',
  'da',
  'fi',
  'hu',
  'no',
  'ro',
  // 11 oficiales de la UE que faltaban
  'bg',
  'cs',
  'el',
  'et',
  'ga',
  'hr',
  'lt',
  'lv',
  'mt',
  'sk',
  'sl',
  // EEE
  'is',
  // cooficiales regionales de España
  'ca',
  'eu',
  'gl',
  // uso menor
  'lb',
  'rm',
  'fy',
  'tr',
] as const;
export type Language = (typeof LANGUAGES)[number];

export const SOURCE_LANGUAGE: Language = 'es';
export const HUMAN_REVIEWED: readonly Language[] = ['es', 'en', 'hu', 'ca'];

/** Idiomas que se OFRECEN al detectar (nunca se fuerzan por país), sección 13. */
export const REGIONAL_OFFERED: readonly Language[] = ['ca', 'eu', 'gl', 'lb', 'rm', 'fy'];

export function isLanguage(v: string): v is Language {
  return (LANGUAGES as readonly string[]).includes(v);
}

/**
 * Módulos: un JSON por módulo e idioma, cargados por ruta (code-splitting). Las claves llevan su
 * propio prefijo y no dependen del fichero (p. ej. `home.json` contiene `catalog.home.*`).
 * `admin` solo existe en español (el resto de idiomas cae al español).
 */
export const MODULES = [
  'common',
  'auth',
  'home',
  'catalog',
  'listing',
  'checkout',
  'orders',
  'shipping',
  'wallet',
  'messages',
  'profile',
  'pro',
  'support',
  'forum',
  'admin',
  'legal2',
  'errors',
  'emails',
  'push',
  'categories',
  'attributes',
  'countries',
  'content',
  'guides',
] as const;
export type I18nModule = (typeof MODULES)[number];

/** Módulos que solo existen en el idioma fuente. */
export const SOURCE_ONLY_MODULES: readonly I18nModule[] = ['admin'];

/**
 * Locale para resolver plurales con Intl.PluralRules / i18next. `pt` es portugués europeo (con la
 * regla brasileña el 0 saldría en singular) y `no` es bokmål.
 */
export const PLURAL_LOCALE: Partial<Record<Language, string>> = { pt: 'pt-PT', no: 'nb' };
export function pluralLocale(lang: Language): string {
  return PLURAL_LOCALE[lang] ?? lang;
}
